import { useEffect, useRef } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useAfterMount from '@rio-cloud/rio-uikit/useAfterMount';
import { ConnectionTypes } from '../services/partnerNetwork.types';
import type { ConnectionType } from '../services/partnerNetwork.types';

export const useRouteState = (callback: () => void) => {
    const { search } = useLocation();
    const searchRef = useRef('');

    useEffect(() => {
        if (searchRef.current === search) {
            return;
        }
        callback();
        searchRef.current = search;
    }, [search]);
};

export const useUpdateRoute = (newSearch: string) => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    useAfterMount(() => {
        if (search !== newSearch) {
            navigate(pathname + newSearch);
        }
    }, [newSearch]);
};

export const useRestrictConnection = (): ConnectionType | undefined => {
    const [searchParams] = useSearchParams();
    const connectionType = searchParams.get('restrictConnectionType') as ConnectionType;
    return Object.values(ConnectionTypes).includes(connectionType) ? connectionType : undefined;
};
